(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    flex-direction: column;\n\n    ", " {\n      justify-content: center;\n      margin-bottom: ", ";\n      flex: 1 0 auto;\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import MuiPagination from '@material-ui/lab/Pagination';
import { Flex } from "../layout";
import { media } from "../../helpers/responsive";
import { SPACE } from "../../constants/style";
var PaginationContainer = styled(Flex).withConfig({
  displayName: "Pagination__PaginationContainer",
  componentId: "sc-4blvlb-0"
})(["flex-direction:row;", "{align-items:center;flex:1 0 0;}", ""], Flex, media.css.mobile.and('down')(_templateObject(), Flex, SPACE.lg));

var Pagination = function Pagination(props) {
  var currentPage = props.currentPage,
      totalPages = props.totalPages,
      totalItems = props.totalItems,
      currentPageItems = props.currentPageItems,
      setCurrentPage = props.setCurrentPage,
      renderShowingString = props.renderShowingString,
      MuiPaginationProps = props.MuiPaginationProps,
      disabled = props.disabled,
      hideNextButton = props.hideNextButton,
      hidePrevButton = props.hidePrevButton,
      showFirstButton = props.showFirstButton,
      showLastButton = props.showLastButton,
      rest = _objectWithoutProperties(props, ["currentPage", "totalPages", "totalItems", "currentPageItems", "setCurrentPage", "renderShowingString", "MuiPaginationProps", "disabled", "hideNextButton", "hidePrevButton", "showFirstButton", "showLastButton"]);

  var handleChange = function handleChange(e, page) {
    setCurrentPage(page);
  };

  return React.createElement(PaginationContainer, rest, typeof renderShowingString === 'function' ? React.createElement(Flex, {
    justifyContent: "flex-start"
  }, renderShowingString(currentPageItems, totalItems)) : null, React.createElement(Flex, {
    justifyContent: "flex-end"
  }, React.createElement(MuiPagination, _extends({
    disabled: disabled,
    hideNextButton: hideNextButton,
    hidePrevButton: hidePrevButton,
    showFirstButton: showFirstButton,
    showLastButton: showLastButton,
    count: totalPages,
    page: currentPage,
    onChange: handleChange
  }, MuiPaginationProps || {}))));
};

Pagination.defaultProps = {
  disabled: false,
  hideNextButton: false,
  hidePrevButton: false,
  showFirstButton: false,
  showLastButton: false,
  renderShowingString: function renderShowingString(currentPageItems, totalItems) {
    return (// Keeping the default simple and language neutral
      "".concat(currentPageItems, " / ").concat(totalItems)
    );
  }
};
Pagination.propTypes = {
  disabled: PropTypes.bool,
  hideNextButton: PropTypes.bool,
  hidePrevButton: PropTypes.bool,
  showFirstButton: PropTypes.bool,
  showLastButton: PropTypes.bool,
  totalItems: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  currentPageItems: PropTypes.number.isRequired,
  renderShowingString: PropTypes.func
};
var _default = Pagination;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(PaginationContainer, "PaginationContainer", "/home/vsts/work/1/s/src/components/pagination/Pagination.js");
  reactHotLoader.register(Pagination, "Pagination", "/home/vsts/work/1/s/src/components/pagination/Pagination.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/pagination/Pagination.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();